var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 488.48 488.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.63,46.84c47.46,4.78,85.23,42.32,88.94,90.09v215.39c-3.62,46.86-41.65,85.38-88.49,89.32h-209.69c-48.53-3.6-86.97-44.21-89.3-92.58,2.88-68.75-3.72-140.47,0-208.87,2.64-48.65,40.6-89.63,89.76-93.35h208.8ZM153.71,78.07c-39.43,4.66-70.02,37.16-72.46,76.8-3.63,59,2.79,121.71.05,181.1,4.01,41.08,36.57,72.79,77.89,75.45,55.72,3.59,115.16-2.66,171.26,0,40.47-2.31,73.61-33.47,77.89-73.82v-186.75c-4.32-38.15-34.88-68.78-73.09-72.91l-181.54.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.46,145.77c80.66-7.15,136.59,76.88,96.55,147.93-36.68,65.07-131.38,66.44-170.45,2.97-37.89-61.55,1.81-144.51,73.9-150.9ZM236.09,170.24c-38.31,3.9-66.41,40.81-64.26,78.46,3.35,58.58,72.08,93.13,118.64,54.22,56.38-47.1,20.02-140.25-54.38-132.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.23,111.47c38.43-1.85,41.74,55.75,5.43,59.34-42.24,4.18-44.67-57.44-5.43-59.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8f86c0975520d6e36cc63303ef15dcbc.svg";
export { ForwardRef as ReactComponent };